import React, { FC, useEffect, useState } from "react";
import { ExperiencesDataType } from "data/types";
import { Link } from "react-router-dom";
import Badge from "./Badge";
import { productType } from "types/productType";
import Badge2 from "./Badge2";
import Badge3 from "./Badge3";

export interface ExperiencesCardProps {
	className?: string;
	ratioClass?: string;
	data?: ExperiencesDataType;
	size?: "default" | "small";
}

//const DEMO_DATA: ExperiencesDataType = DEMO_EXPERIENCES_LISTINGS[0];

const ExperiencesCard: FC<ExperiencesCardProps> = ({
	size = "default",
	className = "",
	data,
	ratioClass = "aspect-w-3 aspect-h-3",
}) => {
	const {
		_id,
		type,
		title,
		price,
		no,
		cover,
		reservationStart,
		reservationEnd,
		category,
		minGuests,
		reserveCount,
		reserveAgency,
		travelAgency_logo,
		travelAgency_name,
		travelStartText,
		travelStartDateText
	}: any = data;

	const [cardStatus, setCardStatus] = useState <string> ("모집중");

	useEffect(() => {

		if ((reserveCount+reserveAgency) >= minGuests) {
			setCardStatus("확정");
		} else {
			setCardStatus("모집중");
		}
		console.log(travelStartText)
		


	}, []);

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			year: year,
			month: month,
			day: day,
		};
	};
	
	const getTripDuration = (
		_reservationStart: string,
		_reservationEnd:string
	  ) => {
		const startDate = new Date(_reservationStart);
		const endDate = new Date(_reservationEnd);

		// Check for special case: both dates are 2023-12-31
		if (startDate.toISOString().startsWith('2023-12-31') && 
			endDate.toISOString().startsWith('2023-12-31')) {
		  return "상시일정";
		}
	  
		// 밀리초 단위로 차이 계산
		const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
		
		// 일 수 차이 계산
		const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	  
		// 시간 차이 계산 (분 단위로 반올림)
		const diffHours = Math.round((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  
		if (diffDays === 0 && diffHours < 24) {
		  return "무박 1일";
		} else if (diffDays === 1 || (diffDays === 0 && diffHours >= 24)) {
		  return "1박 2일";
		} else {
		  return `${diffDays}박 ${diffDays + 1}일`;
		}
	  };

	const _reservationStart = formatKoreanDate(reservationStart);
	const _reservationEnd = formatKoreanDate(reservationEnd);
	const _reservationSchedule = getTripDuration(reservationStart, reservationEnd);


	//console.log(`${no} ${title}`, cover)

	
	const renderContent = () => {

		
		//console.log()
		return (
			<div className={`space-y-[4px] mt-3`}>
				
				<div className="flex items-center space-x-2 text-[0.9rem]">
					<span className="line-clamp-1" style={{fontWeight: "600"}}>{title}</span>
				</div>
				<div className="">
					<div className="md:flex md:justify-between items-center text-sm space-x-2">
						<div className="">
							<div className="flex items-center text-[0.90rem]" style={{fontWeight: "500"}}>
								{travelStartText}
								<span className="pl-1">/ </span>
								출발 {minGuests}인(최소)
							</div>
						</div>
					</div>
				</div>
				<div className="flex">
					<div className="flex">
						{/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.0" stroke="currentColor" className="size-6">
							<path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
						</svg> */}
						<span className="ml-[3px] [0.9rem]"  style={{fontWeight: "500"}}>
							{reserveAgency + reserveCount}명 예약중
						</span>
					</div>
				</div>
				<div className="flex">
					<div className="flex">
						<span className="ml-[3px] [0.9rem]"  style={{fontWeight: "500"}}>
							{travelStartDateText===undefined? "출발일정 없음":travelStartDateText}
						</span>
					</div>
				</div>
				
				<div className="flex justify-end">
					<span className="text-[0.95rem]"  style={{fontWeight: "600"}}>
						{price.toLocaleString('ko-KR')}원
					</span>
				</div>
				<div className="flex items-center space-x-1">
					<Badge
						type={category}
						href={""}
						color={"gray"}
					/>
					<Badge2
						productType={productType}
						type={type}
						href={""}
						color={"gray"}
					/>
					
					{/* <span className="">/ {productType.find ((item: any) => item.key === type).label}</span> */}
				</div>
			</div>
		);
	};



	return (
		<>
		<div
			className={`nc-ExperiencesCard group relative ${className}`}
			data-nc-id="ExperiencesCard"
		>
			<Link to={`/motorcycle/${no}`}>
				<div className="relative w-full aspect-w-1 aspect-h-1">
					<div className="w-full h-full">
					{
						cover === null
						?
							<div className="object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform bg-gray-500" />
						:
							cover.type === "video"
							?
								<video 
									className="object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform"
									loop 
									muted
									autoPlay
									playsInline
									controls={false}
									disablePictureInPicture
									webkit-playsinline="true"
									src={`${process.env.REACT_APP_SERVER_FILE}/products/${no}/${cover.src}`}
								/>
							:
								<img
									src={`${process.env.REACT_APP_SERVER_FILE}/products/${no}/${cover.src}`}
									className={"object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform"}
								/>
					}
					{travelAgency_logo && (
						<div className="absolute top-2 right-2 z-10 flex items-center bg-black/60 rounded-lg pl-2 pr-2 pt-1 pb-1 space-x-2">
							<img 
								src={`${process.env.REACT_APP_SERVER_FILE}/${travelAgency_logo}`}
								className="w-6 h-6 object-contain rounded"
								alt={travelAgency_name}
							/>
							{/* {travelAgency_name && (
								<span className="ml-1 text-md font-semibold text-white">{travelAgency_name}</span>
							)} */}
						</div>
					)}
					{(
						<div className="absolute bottom-2 left-2 z-10 flex items-center rounded-lg p-1">
							<Badge3
								label={cardStatus}
								color={cardStatus==="확정" ? "green" : "red"}	
							/>
						</div>
					)}
					</div>
				</div>

				{renderContent()}
			</Link>
		</div>
		</>
	);
};





export default ExperiencesCard;
